import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class WarehousesBudget extends Component{ 

    constructor(props){
      super(props);

      this.state={
          budgetwarehouse:[],
          modalTitle:"",
          bugetwarehouseid:0,
          fyname_w: "",
		      regionname_w: "",
		      warehousename_w: "",
		      origin_charges_w: "",
		      freight_w: "",
		     destination_charges_w: "",
		     customs_duties_w: "",
		     vat_w: "",
		     warehousing_w: "",
		     kitting_vas_w: "",
		     last_delivery_mile_w: "",
		     return_flow_w: "",
		     additional_fees_w: "",
		     purchases_costs_w: "",
         transferts_costs_w:"",
		     total_budget_warehouse_w: "",

          CountryNameFilter:"",
          Country0NameFilter:"",
          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          BugetWarehouseIdFilter:"",
          CurrentYearFilter:"",
          budgetwarehouseWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,

          tf_budgetwarehouse:[],
          tf_bugetwarehouseid:0,
          tf_fyname_w: "",
		      tf_regionname_w: "",
		      tf_warehousename_w: "",
		      tf_freight_w: "",
          tf_destination_charges_w: "",
          tf_customs_duties_w: "",
          tf_vat_w: "",
          tf_warehousing_w: "",
          tf_purchases_costs_w: "",
          tf_total_budget_warehouse_w: "",

          TfRegionNameFilter:"",
          TfWarehouseNameFilter:"",
          TfFiscalYearFilter:"",
          TfBugetWarehouseIdFilter:"",
          TfbudgetwarehouseWithoutFilter:[],
      }
  }

  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var BugetWarehouseIdFilter = this.state.BugetWarehouseIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;

    var filteredData=this.state.budgetwarehouseWithoutFilter.filter(
        function(el){
            return el.regionname_w.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehousename_w.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname_w.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.bugetwarehouseid.toString().toLowerCase().includes(
                BugetWarehouseIdFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({budgetwarehouse:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.budgetwarehouseWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({budgetwarehouse:sortedData});

}



FilterFnTf(){
  var TfRegionNameFilter = this.state.TfRegionNameFilter;
  var TfWarehouseNameFilter = this.state.TfWarehouseNameFilter;
  var TfFiscalYearFilter = this.state.TfFiscalYearFilter;
  var TfBugetWarehouseIdFilter = this.state.TfBugetWarehouseIdFilter;

  var filteredData=this.state.TfbudgetwarehouseWithoutFilter.filter(
      function(el){
          return el.tf_regionname_w.toString().toLowerCase().includes(
              TfRegionNameFilter.toString().trim().toLowerCase()
          )&&  
              el.tf_warehousename_w.toString().toLowerCase().includes(
              TfWarehouseNameFilter.toString().trim().toLowerCase()
          )&&  
              el.tf_fyname_w.toString().toLowerCase().includes(
              TfFiscalYearFilter.toString().trim().toLowerCase()
          )&&  
              el.tf_bugetwarehouseid.toString().toLowerCase().includes(
              TfBugetWarehouseIdFilter.toString().trim().toLowerCase()
          )
      }
  );

  this.setState({tf_budgetwarehouse:filteredData});

}

sortResultTf(prop,asc){
var sortedData=this.state.TfbudgetwarehouseWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({tf_budgetwarehouse:sortedData});

}




changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


changeBugetWarehouseIdFilter = (e)=>{
    this.state.BugetWarehouseIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }


  TfchangeRegionNameFilter = (e)=>{
    this.state.TfRegionNameFilter=e.target.value;
    this.FilterFnTf();
  }

TfchangeWarehouseNameFilter = (e)=>{
    this.state.TfWarehouseNameFilter=e.target.value;
    this.FilterFnTf();
  }

TfchangeFiscalYearFilter = (e)=>{
    this.state.TfFiscalYearFilter=e.target.value;
    this.FilterFnTf();
  }


TfchangeBugetWarehouseIdFilter = (e)=>{
    this.state.TfBugetWarehouseIdFilter=e.target.value;
    this.FilterFnTf();
  }


refreshList = () => {
    axiosService.get('/finalbudgetwarehouse/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ budgetwarehouse: data, budgetwarehouseWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


  refreshListTf = () => {
    axiosService.get('/transferts_finalbudgetwarehouse/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ tf_budgetwarehouse: data, TfbudgetwarehouseWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

componentDidMount(){
  this.refreshList();
  this.refreshListTf();
}



render(){
  const {
      budgetwarehouse,
      modalTitle,
      bugetwarehouseid,
      fyname_w,
		  regionname_w,
		  warehousename_w,
		  origin_charges_w,
		  freight_w,
		 destination_charges_w,
		customs_duties_w,
		vat_w,
		     warehousing_w,
		     kitting_vas_w,
		     last_delivery_mile_w,
		     return_flow_w,
		     additional_fees_w,
		     purchases_costs_w,
         transferts_costs_w,
		     total_budget_warehouse_w,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear,


      tf_budgetwarehouse,
      tf_bugetwarehouseid,
      tf_fyname_w,
		  tf_regionname_w,
		  tf_warehousename_w,
		  tf_freight_w,
      tf_destination_charges_w,
      tf_customs_duties_w,
      tf_vat_w,
      tf_warehousing_w,
      tf_purchases_costs_w,
      tf_total_budget_warehouse_w,

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsWarehouses />

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Warehouses Budget
    </div>

<div className="table-container">
<table className="table table-striped">
<thead>
<tr  className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Origin Charges Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Freight Warehouse 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Destination Charges Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Customs Duties Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Vat Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Warehousing Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Kitting & Vas Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Last Delivery Mile Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Return Flow Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Additional Fees Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Purchases Costs Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Costs Warehouse
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Budget Warehouse 
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {budgetwarehouse.map(dep=>
      <tr key={dep.bugetwarehouseid} className="row-hover">
          <td className="table-text">{dep.fyname_w ?? 'N/A'}</td>
<td className="table-text">{dep.regionname_w ?? 'N/A'}</td>
<td className="table-text">{dep.warehousename_w ?? 'N/A'}</td>
<td className="table-text">{dep.origin_charges_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.origin_charges_w) : 'N/A'}</td>
<td className="table-text">{dep.freight_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.freight_w) : 'N/A'}</td>
<td className="table-text">{dep.destination_charges_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.destination_charges_w) : 'N/A'}</td>
<td className="table-text">{dep.customs_duties_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.customs_duties_w) : 'N/A'}</td>
<td className="table-text">{dep.vat_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.vat_w) : 'N/A'}</td>
<td className="table-text">{dep.warehousing_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.warehousing_w) : 'N/A'}</td>
<td className="table-text">{dep.kitting_vas_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.kitting_vas_w) : 'N/A'}</td>
<td className="table-text">{dep.last_delivery_mile_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.last_delivery_mile_w) : 'N/A'}</td>
<td className="table-text">{dep.return_flow_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.return_flow_w) : 'N/A'}</td>
<td className="table-text">{dep.additional_fees_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.additional_fees_w) : 'N/A'}</td>
<td className="table-text">{dep.purchases_costs_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.purchases_costs_w) : 'N/A'}</td>
<td className="table-text">{dep.transferts_costs_w? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.transferts_costs_w) : 'N/A'}</td>
<td className="table-text">{dep.total_budget_warehouse_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.total_budget_warehouse_w) : 'N/A'}</td>

          <td>
            

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>


<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Transferts Budget Details
    </div>

<div className="table-container">
<table className="table table-striped">
<thead>
<tr  className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.TfchangeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.TfchangeRegionNameFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.TfchangeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Freight Warehouse 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Destination Charges Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Customs Duties Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Vat Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Warehousing Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Purchases Costs Warehouse
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Transferts Total Budget Warehouse 
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {tf_budgetwarehouse.map(dep=>
      <tr key={dep.tf_bugetwarehouseid} className="row-hover">
          <td className="table-text">{dep.tf_fyname_w ?? 'N/A'}</td>
<td className="table-text">{dep.tf_regionname_w ?? 'N/A'}</td>
<td className="table-text">{dep.tf_warehousename_w ?? 'N/A'}</td>
<td className="table-text">{dep.tf_freight_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_freight_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_destination_charges_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_destination_charges_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_customs_duties_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_customs_duties_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_vat_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_vat_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_warehousing_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_warehousing_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_purchases_costs_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_purchases_costs_w) : 'N/A'}</td>
<td className="table-text">{dep.tf_total_budget_warehouse_w ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_total_budget_warehouse_w) : 'N/A'}</td>

          <td>
            

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

</div>
  )
}
  }




